import asBentoPage from 'common/bento/hoc/asBentoPage';
import Heading from 'components/_core/Heading';
import Text from 'components/_core/Text';
import OpenHelpButton from 'features/Help/components/OpenHelpButton';
import ApplicationProblemImage from 'features/Onboarding/components/ApplicationProblemImage';
import OBNavigation from 'features/Onboarding/components/OBNavigation/OBNavigation';

import ChillDude from './assets/ChillDude@2x.png';
import locales from './locales';

const ShareholdersCompanyOwnership = asBentoPage(({ Layout, onPrev }) => (
  <Layout nav={<OBNavigation onPrev={onPrev} />}>
    <ApplicationProblemImage src={ChillDude} />

    <Heading marginBlockEnd="space-16" size="lg">
      {locales.title}
    </Heading>

    <Text marginBottom="space-32" variant="primary">
      {locales.description}
    </Text>

    <OpenHelpButton isExpanded>{locales.button}</OpenHelpButton>
  </Layout>
));

export default ShareholdersCompanyOwnership;
